module.exports = __webpack_public_path__ + "static/media/php-logo.151c788f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/php-logo.svg
// module id = 85
// module chunks = 0